import { defineStore } from 'pinia'
import { services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'

export const useInvinityStore = defineStore('invinityStore', {
	state: () => ({
		currentInvSummary: {}
	}),
	actions: {
		async exportProposalToLMS(customer_id, proposal_id, params = {}) {
			return await axios.post(services.invinity + 'customer/clone/' + parseInt(customer_id) + '/proposal/' + parseInt(proposal_id), params, { headers: getHeader() })
				.then(res=>{
					return res.data;
				})
				.catch(e=>{
					_gNotif.errorFunction(e)
					return null;
				});
		},

		getDropdownList(type) {
			return new Promise((resolve, reject) => {
				const repayList = _gHlp.getLocalStorage('invinity.opt_' + type)
				if (!_gHlp.isEmpty(repayList)) {
					resolve(repayList)
				} else {
					axios.get(services.invinity + 'droplist?type=' + type, { headers: getHeader() })
						.then(res => {
							_gHlp.setLocalStorage('invinity.opt_repayments', res.data)
							resolve(res.data);
						}).catch(error => {
							_gNotif.errorFunction(error);
							reject(error); // Reject the Promise with the error
						});
				}
			});
		},

		async createDropdownList(params) {
			try {
				let res = await axios.post(`${services.invinity}droplist`,params,{ headers: getHeader()});
				return _gHlp.getValue(res.data);
			} catch (err) {
				_gNotif.errorFunction(err)
				return null
			}
		},
		async updateDropdownList(id, params) {
			try {
				let res = await axios.patch(`${services.invinity}droplist`,params,{ headers: getHeader()});
				return _gHlp.getValue(res.data);
			} catch (err) {
				_gNotif.errorFunction(err)
				return null
			}
		},
		async deleteDropdownList(id) {
			try {
				let res = await axios.delete(`${services.invinity}droplist/${id}`,{ headers: getHeader()});
				return _gHlp.getValue(res.data);
			} catch (err) {
				_gNotif.errorFunction(err)
				return null
			}
		},
		getInvSummary(psal_id) {
			return new Promise((resolve, reject) => {
				const repayList = _gHlp.getLocalStorage('invinity.summary')
				axios.get(services.invinity + 'loan-ec/summary/' + psal_id, { headers: getHeader() })
					.then(res => {
						this.currentInvSummary = res.data.data;
						resolve(res.data.data);
					}).catch(error => {
						_gNotif.errorFunction(error);
						reject(error); // Reject the Promise with the error
					});

			});
		},

		syncToLms(psal_id = null) {
			axios.post(`${services.invinity}sync-sas/${psal_id}`,{},{ headers: getHeader()})
			.then(res=>{
				return res.data;
			})
			.catch(e=>{
				_gNotif.errorFunction(e)
			});
		}

	}
})